var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.name,_vm._b({tag:"component",staticClass:"cxm-Icon",class:{ '-pointer': _vm.handleClick },nativeOn:{"click":function($event){return _vm.clickMethod.apply(null, arguments)}}},'component',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }